import { useMarketingLang } from "../i18n.jsx";

export default function Footer() {
  const { t } = useMarketingLang();
  return (
    <footer
      className="bg-bg-footer border-t-[0.5px] border-white/[0.06]"
      style={{ background: "#070a12" }}
    >
      <div className="container-page py-14">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p
            className="font-mono text-[11px] uppercase text-white/35"
            style={{ letterSpacing: "0.21em" }}
          >
            SEIDR · Oslo
          </p>
          <p
            className="font-mono text-[11px] uppercase text-white/35"
            style={{ letterSpacing: "0.21em" }}
          >
            {t('footer.tagline')}
          </p>
        </div>

        <p
          className="mt-10 text-center font-mono text-[11px] uppercase text-white/25"
          style={{ letterSpacing: "0.21em" }}
        >
          {t('footer.partnership')}
        </p>
      </div>
    </footer>
  );
}
